module.exports = __webpack_public_path__ + "6c5aefbf06f11da118debea93e348e87.png";